// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIKE = "To se mi l\u00edb\u00ed";
export const UNLIKE = "U\u017e se mi to nel\u00edb\u00ed";
